import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "./config";

/**
 * Creates a properly formatted storage reference path that follows security rules
 * @param {string} collection - The storage collection (e.g., 'userProfilePhoto')
 * @param {string} userId - The user ID
 * @param {string} filename - Optional filename
 * @returns {string} Properly formatted storage path
 */
export const createStoragePath = (collection, userId, filename = 'profile') => {
  return `${collection}/${userId}_${filename}`;
};

/**
 * Uploads a file to Firebase Storage with proper formatting
 * @param {string} collection - Storage collection (e.g., 'userProfilePhoto')
 * @param {string} userId - User ID
 * @param {File} file - File to upload
 * @param {string} filename - Optional custom filename
 * @returns {Promise<string>} Download URL for the uploaded file
 */
export const uploadUserFile = async (collection, userId, file, filename = 'profile') => {
  try {
    // Generate a properly formatted path
    const path = createStoragePath(collection, userId, filename);
    const storageRef = ref(storage, path);
    
    // Upload file
    await uploadBytes(storageRef, file);
    
    // Get and return download URL
    const downloadURL = await getDownloadURL(storageRef);
    return downloadURL;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
}; 